import(/* webpackMode: "eager" */ "/home/runner/_work/px-painel/px-painel/app/(public)/privacy-policy/page.tsx");
